// client/src/routes/portal/incidents/$incidentId.tsx — SCR-PORT-004's detail · the incidents board.
//
// A route of its own rather than a `<dialog>` over the list, and the reason is the one D-1190
// gave for SCR-OAT-001's cost form and this feature's own report form: §11.2's sticky bottom
// action bar is `fixed` to the viewport, and inside a dialog's top layer a fixed bar lands over
// the page instead of over the panel. It is also the right shape for the content — a tenant
// sends this link to the landlord, Back returns to the list with its filters intact, and a
// reload lands on the incident rather than on page 1 of everything.
//
// `/portal/incidents/$id` sits UNDER `/portal/incidents` in the URL but is a sibling route in
// the tree, which is what the §6.6 tab bar already expects: `portal-nav.ts` highlights
// „Incidente" for anything beginning with that path, derived rather than hand-flagged.
//
// No `validateSearch` of its own. The only param this screen reads is `contract`, and that one
// is on the `/portal` LAYOUT route's schema — part of the full search of every `/portal/*`
// screen, which is what keeps „which of my contracts am I looking at" one fact and not six
// screens' component state (D-1180).

import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { PageHeader } from '@/components/layout/PageHeader';
import { IncidentDetailScreen } from '@/features/portal/IncidentDetail';

export const Route = createFileRoute('/portal/incidents/$incidentId')({
  component: PortalIncidentDetailScreen,
});

function PortalIncidentDetailScreen() {
  const { t } = useTranslation();
  const { incidentId } = Route.useParams();

  return (
    <>
      <PageHeader
        title={t('portal.incidents.detailTitle')}
        description={t('portal.incidents.detailSubtitle')}
      />

      <IncidentDetailScreen incidentId={incidentId} />
    </>
  );
}
